import { fmtTime } from "@/lib/api";
import { STATUS } from "@/lib/organs";

export default function HealthStatus({ health, large = false }) {
  if (!health) return null;
  const st = STATUS[health.status] || STATUS.GREY;
  return (
    <div data-testid="health-status" className="glass rounded-3xl p-6 fade-up">
      <div className="flex items-start gap-4">
        <span className={`relative mt-1.5 rounded-full ${large ? "w-5 h-5" : "w-4 h-4"} pulse-ring`}
          style={{ background: st.color, color: st.color, boxShadow: `0 0 16px ${st.glow}` }} />
        <div className="flex-1 min-w-0">
          <div className="text-xs tracking-[0.25em] text-gray-500 mb-1">STATO DI SALUTE DELL'AZIENDA</div>
          <h2 className={`font-display font-bold ${large ? "text-2xl" : "text-xl"}`} style={{ color: st.color }} data-testid="health-status-label">
            ● {st.label.toUpperCase()}
          </h2>
          <p className="text-sm text-gray-400 mt-2">{health.message}</p>
          <div className="mt-4">
            <div className="flex flex-wrap justify-between gap-x-2 gap-y-1 text-xs text-gray-500 mb-1.5">
              <span>Situazione aggiornata alle {fmtTime(health.updated_at)}</span>
              <span data-testid="health-coverage">Copertura dati: {health.coverage}%</span>
            </div>
            <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
              <div className="h-full rounded-full transition-all duration-700"
                style={{ width: `${health.coverage}%`, background: "linear-gradient(90deg,#3B82F6,#00E5FF)", boxShadow: "0 0 8px rgba(0,229,255,0.5)" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
